import React, { useState } from "react";
import { IStorageGameData } from "../../../../types";

import "./Share.component.scss";

type Props = {
  gameData: IStorageGameData;
  brandName: string;
  gameNumber: number;
};

const Share = (props: Props) => {
  const [buttonText, setButtonText] = useState("Share");
  const { gameData, brandName, gameNumber } = props;
  const guessBlocks: JSX.Element[] = [];
  let stringBlocks = "";

  const title = gameData.currentGame.guesses.includes(brandName, 0) ? (
    <h2>You got it!</h2>
  ) : (
    <h2>The answer was: {brandName}</h2>
  );

  for (let i = 0; i < 5; i++) {
    if (
      gameData.currentGame.guesses[i] &&
      gameData.currentGame.guesses[i] !== brandName
    ) {
      guessBlocks.push(
        <div key={i} className="guesses__guess-block fail"></div>
      );
      stringBlocks = stringBlocks.concat(" 🅱️ ");
    } else if (
      gameData.currentGame.guesses[i] &&
      gameData.currentGame.guesses[i] === brandName
    ) {
      guessBlocks.push(
        <div key={i} className="guesses__guess-block win"></div>
      );
      stringBlocks = stringBlocks.concat(" 🟩 ");
    } else if (!gameData.currentGame.guesses[i]) {
      guessBlocks.push(<div key={i} className="guesses__guess-block"></div>);
      stringBlocks = stringBlocks.concat(" ⬛ ");
    }
  }

  const shareString = `BRANDLE #${gameNumber}${stringBlocks}https://brandle.dysrupt.com`;

  const copy = () => {
    navigator.clipboard.writeText(shareString);
    setButtonText("Copied!");
    setTimeout(() => {
      setButtonText("Share");
    }, 3000);
  };

  return (
    <div className="share">
      {title}
      <div className="guesses">
        {guessBlocks.map((item: JSX.Element) => item)}
      </div>
      <button className="share_button" onClick={copy}>
        {buttonText}
      </button>
    </div>
  );
};

export default Share;
